// VNEC v9 — pages/ngan-sach.js
// Ngân sách/dự toán per HĐ × loại CP × kỳ
import { supabase, getCurrentUser } from '../lib/supabase.js';
import { formatVND } from '../lib/forms.js';

let _state = { rows: [], user: null, editingMaNS: null };

export function renderNganSach() {
  window.__pageInit = initNganSach;
  return `
    <div class="crud-wrap">
      <div class="page-hd">
        <h2>Ngân sách / Dự toán</h2>
        <div>
          <button class="btn btn-primary btn-sm" id="ns-new">+ Tạo ngân sách</button>
          <button class="btn btn-ghost btn-sm" id="ns-refresh">⟳</button>
        </div>
      </div>
      <div class="crud-filters">
        <input type="text" class="inp" id="f-search" placeholder="Tìm mã NS, mã HĐ, tên dự án…" style="min-width:280px">
        <select class="inp" id="f-status">
          <option value="">Tất cả trạng thái</option>
          <option value="draft">Nháp</option><option value="pending_l1">Chờ duyệt</option>
          <option value="pending_l2">Duyệt L1</option><option value="approved">Đã duyệt</option>
          <option value="rejected">Từ chối</option>
        </select>
      </div>
      <div id="ns-table" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>
      <div id="ns-modal" class="modal-overlay" style="display:none"></div>
    </div>`;
}

async function initNganSach() {
  _state.user = await getCurrentUser();
  document.getElementById('ns-new').addEventListener('click', () => openForm(null));
  document.getElementById('ns-refresh').addEventListener('click', load);
  document.getElementById('f-search').addEventListener('input', renderTable);
  document.getElementById('f-status').addEventListener('change', renderTable);
  await load();
}

async function load() {
  try {
    const { data, error } = await supabase.from('ngan_sach')
      .select('*').is('deleted_at', null).order('created_at', { ascending: false }).limit(2000);
    if (error) throw error;
    // Group by ma_ngan_sach (since v8 stores multi-row per NS)
    const groups = new Map();
    (data || []).forEach(r => {
      const k = r.ma_ngan_sach;
      if (!groups.has(k)) {
        groups.set(k, { ma_ngan_sach: k, ma_hd: r.ma_hd, ten_du_an: r.ten_du_an,
          nam: r.nam, ky: r.ky, trang_thai: r.trang_thai, created_by: r.created_by,
          created_at: r.created_at, ma_du_an: r.ma_du_an, so_dong: 0, tong_kh: 0, tong_tt: 0, rows: [] });
      }
      const g = groups.get(k);
      g.so_dong++;
      g.tong_kh += parseFloat(r.ngan_sach_kh || 0) || 0;
      g.tong_tt += parseFloat(r.thuc_te || 0) || 0;
      g.rows.push(r);
    });
    _state.rows = Array.from(groups.values());
    renderTable();
  } catch (e) {
    document.getElementById('ns-table').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderTable() {
  const q = (document.getElementById('f-search').value || '').toLowerCase();
  const st = document.getElementById('f-status').value;
  const rows = _state.rows.filter(r =>
    (!st || r.trang_thai === st) &&
    (!q || (r.ma_ngan_sach || '').toLowerCase().includes(q) || (r.ma_hd || '').toLowerCase().includes(q) || (r.ten_du_an || '').toLowerCase().includes(q))
  );
  if (!rows.length) { document.getElementById('ns-table').innerHTML = '<div class="empty">Không có ngân sách</div>'; return; }

  let html = '<table class="tbl"><thead><tr><th>Mã NS</th><th>Mã HĐ</th><th>Dự án</th><th class="c">Năm</th><th class="c">Kỳ</th><th class="c">Dòng</th><th class="r">KH</th><th class="r">Thực tế</th><th class="c">TT</th><th class="c">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += `<tr>
      <td><b>${escH(r.ma_ngan_sach)}</b></td>
      <td>${escH(r.ma_hd || '—')}</td>
      <td>${escH(r.ten_du_an || '')}</td>
      <td class="c">${r.nam || ''}</td>
      <td class="c">${escH(r.ky || '')}</td>
      <td class="c">${r.so_dong}</td>
      <td class="r money">${formatVND(r.tong_kh)}</td>
      <td class="r money">${formatVND(r.tong_tt)}</td>
      <td class="c">${stBadge(r.trang_thai)}</td>
      <td class="c">
        <button class="btn-mini view" data-act="edit" data-key="${escH(r.ma_ngan_sach)}">Sửa</button>
        ${r.trang_thai === 'draft' ? `<button class="btn-mini reject" data-act="delete" data-key="${escH(r.ma_ngan_sach)}">Xóa</button>` : ''}
      </td>
    </tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('ns-table').innerHTML = html;

  document.querySelectorAll('#ns-table button[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.act === 'edit') openForm(btn.dataset.key);
      else if (btn.dataset.act === 'delete') doDelete(btn.dataset.key);
    });
  });
}

async function openForm(maNS) {
  _state.editingMaNS = maNS;
  const modal = document.getElementById('ns-modal');
  modal.style.display = 'flex';

  let group = null;
  if (maNS) group = _state.rows.find(r => r.ma_ngan_sach === maNS);

  const duAnList = (await supabase.from('du_an').select('ma_du_an,ten_du_an').eq('trang_thai', 'active')).data || [];
  const loaiCPList = (await supabase.from('dm_loai_chi_phi').select('loai_cp').order('loai_cp')).data || [];

  modal.innerHTML = `
    <div class="modal-box modal-lg">
      <div class="m-hd"><div class="m-title">${maNS ? 'Sửa ngân sách: ' + escH(maNS) : 'Tạo ngân sách mới'}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <form id="ns-form">
          <div class="fg">
            <label class="field"><span>Mã HĐ</span><input name="ma_hd" class="inp" value="${escH(group?.ma_hd || '')}"></label>
            <label class="field"><span>Dự án</span><select name="ma_du_an" class="inp"><option value="">—</option>${duAnList.map(d => `<option value="${escH(d.ma_du_an)}"${group?.ma_du_an===d.ma_du_an?' selected':''}>${escH(d.ma_du_an)} — ${escH(d.ten_du_an)}</option>`).join('')}</select></label>
            <label class="field"><span>Tên dự án</span><input name="ten_du_an" class="inp" value="${escH(group?.ten_du_an || '')}"></label>
            <label class="field"><span>Năm</span><input name="nam" type="number" class="inp" value="${group?.nam || new Date().getFullYear()}"></label>
            <label class="field"><span>Kỳ</span><select name="ky" class="inp"><option value="Cả năm"${group?.ky==='Cả năm'?' selected':''}>Cả năm</option><option value="Q1"${group?.ky==='Q1'?' selected':''}>Q1</option><option value="Q2"${group?.ky==='Q2'?' selected':''}>Q2</option><option value="Q3"${group?.ky==='Q3'?' selected':''}>Q3</option><option value="Q4"${group?.ky==='Q4'?' selected':''}>Q4</option></select></label>
          </div>
          <div class="rows-hd"><h4>Hạng mục ngân sách</h4><button type="button" class="btn btn-ghost btn-sm" id="add-row">+ Thêm dòng</button></div>
          <table class="rows-tbl">
            <thead><tr><th style="width:30px">#</th><th>Hạng mục</th><th>Loại CP</th><th style="width:100px">Loại NS</th><th class="r" style="width:140px">KH (VNĐ)</th><th class="r" style="width:140px">Thực tế</th><th style="width:30px"></th></tr></thead>
            <tbody id="rows-body"></tbody>
          </table>
          <div class="modal-actions"><button type="button" class="btn btn-ghost" id="cancel">Hủy</button><button type="submit" class="btn btn-primary">Lưu</button></div>
        </form>
      </div>
    </div>`;

  const body = document.getElementById('rows-body');
  const existingRows = group?.rows || [{}];
  existingRows.forEach(r => addRowToForm(body, loaiCPList, r));
  if (!existingRows.length) addRowToForm(body, loaiCPList, {});

  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('cancel').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('add-row').addEventListener('click', () => addRowToForm(body, loaiCPList, {}));
  document.getElementById('ns-form').addEventListener('submit', e => { e.preventDefault(); submitForm(); });
}

function addRowToForm(body, loaiCPList, r) {
  const tr = document.createElement('tr');
  const idx = body.children.length + 1;
  tr.innerHTML = `
    <td class="c">${idx}</td>
    <td><input class="inp" name="hang_muc" value="${escH(r.hang_muc || '')}"></td>
    <td><select class="inp" name="loai_chi_phi"><option value="">—</option>${loaiCPList.map(l => `<option value="${escH(l.loai_cp)}"${r.loai_chi_phi===l.loai_cp?' selected':''}>${escH(l.loai_cp)}</option>`).join('')}</select></td>
    <td><select class="inp" name="loai"><option value="truc_tiep"${(r.loai||'truc_tiep')==='truc_tiep'?' selected':''}>Trực tiếp</option><option value="phan_bo"${r.loai==='phan_bo'?' selected':''}>Phân bổ</option></select></td>
    <td><input class="inp r" name="ngan_sach_kh" value="${r.ngan_sach_kh ? formatVND(r.ngan_sach_kh) : ''}"></td>
    <td><input class="inp r" name="thuc_te" value="${r.thuc_te ? formatVND(r.thuc_te) : ''}"></td>
    <td class="c"><button type="button" class="btn-mini reject" data-act="del">×</button></td>
  `;
  body.appendChild(tr);
  tr.querySelector('[data-act="del"]').addEventListener('click', () => {
    tr.remove();
    Array.from(body.children).forEach((el,i) => el.children[0].textContent = i+1);
  });
}

async function submitForm() {
  const form = document.getElementById('ns-form');
  const fd = new FormData(form);
  const nam = parseInt(fd.get('nam')) || new Date().getFullYear();
  const ma_hd = fd.get('ma_hd') || '';
  const ky = fd.get('ky');
  const ma_du_an = fd.get('ma_du_an') || null;
  const ten_du_an = fd.get('ten_du_an') || '';

  // Collect rows
  const body = document.getElementById('rows-body');
  const rows = Array.from(body.children).map((tr, i) => {
    const hang_muc = tr.querySelector('[name="hang_muc"]').value.trim();
    const loai_chi_phi = tr.querySelector('[name="loai_chi_phi"]').value;
    if (!hang_muc && !loai_chi_phi) return null;
    return {
      so_thu_tu: (i+1).toString(),
      hang_muc,
      loai_chi_phi,
      loai: tr.querySelector('[name="loai"]').value,
      ngan_sach_kh: parseVND(tr.querySelector('[name="ngan_sach_kh"]').value),
      thuc_te: parseVND(tr.querySelector('[name="thuc_te"]').value)
    };
  }).filter(Boolean);

  if (!rows.length) { toast('Thêm ít nhất 1 hạng mục', 'err'); return; }

  try {
    const maNS = _state.editingMaNS || await genMaNS(nam);
    // Delete old rows if editing
    if (_state.editingMaNS) {
      const { error: delErr } = await supabase.from('ngan_sach').delete().eq('ma_ngan_sach', maNS);
      if (delErr) throw delErr;
    }
    // Insert new rows
    const payload = rows.map(r => ({
      ma_ngan_sach: maNS, ma_hd, ten_du_an, nam, ky, ma_du_an,
      so_thu_tu: r.so_thu_tu, hang_muc: r.hang_muc, loai_chi_phi: r.loai_chi_phi, loai: r.loai,
      ngan_sach_kh: r.ngan_sach_kh, thuc_te: r.thuc_te,
      trang_thai: 'draft', 
    }));
    const { error } = await supabase.from('ngan_sach').insert(payload);
    if (error) throw error;
    toast(_state.editingMaNS ? 'Đã cập nhật' : 'Đã tạo: ' + maNS, 'ok');
    document.getElementById('ns-modal').style.display = 'none';
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function genMaNS(nam) {
  const { data } = await supabase.from('ngan_sach').select('ma_ngan_sach').like('ma_ngan_sach', `NS-${nam}-%`).order('ma_ngan_sach', { ascending: false }).limit(1);
  const last = data && data[0] ? parseInt(data[0].ma_ngan_sach.split('-')[2]) || 0 : 0;
  return `NS-${nam}-${String(last + 1).padStart(3, '0')}`;
}

async function doDelete(maNS) {
  if (!confirm(`Xóa ngân sách ${maNS}?`)) return;
  try {
    const { error } = await supabase.from('ngan_sach').update({ deleted_at: new Date().toISOString() }).eq('ma_ngan_sach', maNS);
    if (error) throw error;
    toast('Đã xóa', 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

function stBadge(st) {
  const map = { Draft:['Nháp','draft'], Pending:['Chờ duyệt','pending'], Approved_L1:['Duyệt L1','l1'], Approved:['Đã duyệt','approved'], Rejected:['Từ chối','rejected'] };
  const [lb, cls] = map[st] || ['—','draft'];
  return `<span class="badge-st badge-${cls}">${lb}</span>`;
}
function escH(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function parseVND(s) { return parseFloat(String(s||'').replace(/[.,\s]/g, '')) || 0; }
function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div'); el.className = 'toast toast-' + type; el.textContent = msg;
  c.appendChild(el); setTimeout(() => el.remove(), 3500);
}
